import axios, { AxiosError, AxiosResponse } from "axios";
import { Base_Url } from "./constants/base_url";

const $axios = axios.create({
  baseURL: Base_Url,
});

$axios.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("BscToken");
    const language = localStorage.getItem("bsc-lang") || "";
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    config.headers["Accept-Language"] = language.toLocaleLowerCase();
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);
$axios.interceptors.response.use(
  async (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// $axios.interceptors.response.use(
//   (response: AxiosResponse) => response,
//   (error: AxiosError<{ message?: string }>) => {
//     console.log(error.status);

//     if (error.status === 404 && window.location.pathname !== "/") {
//       window.location.href = "/not-found";
//       return;
//     }
//     return Promise.reject(error);
//   }
// );
$axios.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError<{ message?: string }>) => {
    // yalnız müəyyən path-ləri redirect et
    const path = window.location.pathname;

  

    return Promise.reject(error);
  }
);

export default $axios;
